// React ve hook'ları içe aktarma
import React, { useEffect, useRef, useState } from 'react'
// Ant Design bileşenleri - UI elemanları için
import { Tooltip, Button, Col, Card, Input, Radio, Row, Select, message, Upload, Spin } from 'antd';
// Ant Design ikonları - butonlar ve görseller için
import { InfoCircleOutlined, PlusCircleOutlined, PlusOutlined, CloseCircleOutlined, PhoneOutlined, LinkOutlined, CloseOutlined, LoadingOutlined, ArrowLeftOutlined, UnorderedListOutlined } from '@ant-design/icons';
// CSS dosyası - özel stiller için
import './Steps.css';
// Network işlemleri için API katmanı
import network from 'network/network';
// Sayfa yönlendirme için React Router hook'u
import { useNavigate } from 'react-router-dom';
// Özel template bileşenleri
import TemplateInput from 'components/Elements/TemplateInput';
import TemplateSelectBox from 'components/Elements/TemplateSelectBox';
import TemplateMediaSelectBox from 'components/Elements/TemplateMediaSelectBox';
import TemplateTextArea from 'components/Elements/TemplateTextArea';

// Benzersiz ID oluşturmak için UUID kütüphanesi
import { v4 as uuidv4 } from 'uuid';
// Layout bileşeni
import Flex from 'components/shared-components/Flex';
// React transition hook'u (kullanılmıyor gibi görünüyor)
import { useTransition } from 'react';
// Çok dilli destek için i18n hook'u
import { useTranslation } from 'react-i18next';
// Yeniden kullanılabilir buton bileşeni
import ReusableButton from 'components/Elements/ReusableButton';
// Emoji seçici bileşeni (şu anda kullanılmıyor)
import EmojiPicker from 'emoji-picker-react';


/**
 * WhatsApp Template Oluşturma Bileşeni
 * Bu component WhatsApp Business API için şablon mesajları oluşturmaya yarar.
 * Kullanıcılar metin, resim, video ve dokuman içeren şablonlar oluşturabilir.
 */
const CreateTemplate = (props) => {
    // Çok dilli destek için translation hook'u
    const { t, i18n } = useTranslation();
    
    // Desteklenen diller listesi - WhatsApp Business API tarafından desteklenen diller
    const languageData = [
        {
            "key": "tr",
            "value": t("turkish"), // Türkçe
        },
        {
            "value": "English(US)",
            "key": "en_US" // Amerikan İngilizcesi
        },
        {
            "value": "English(UK)",
            "key": "en_GB" // İngiliz İngilizcesi
        }, {
            "value": "Azerbaijani",
            "key": "az" // Azerbaycan Türkçesi
        }, {
            "value": "Czech",
            "key": "cs" // Çekçe
        }, {
            "value": "French",
            "key": "fr" // Fransızca
        }, {
            "value": "German",
            "key": "de" // Almanca
        }, {
            "value": "Irish",
            "key": "ga" // İrlandaca
        }, {
            "value": "Italian",
            "key": "it" // İtalyanca
        }, {
            "value": "Spanish",
            "key": "es" // İspanyolca
        }, {
            "value": "Japanese",
            "key": "ja" // Japonca
        }, {
            "value": "Korean",
            "key": "ko" // Korece
        }
    ]
    // Template başlık (header) türleri - WhatsApp şablonlarında desteklenen medya türleri
    const headerData = [
        {
            key: 0,
            value: t('none'), // Başlık yok - sadece metin şablonu
        },
        {
            key: 1,
            value: t('text'), // Metin başlığı
        },
        {
            key: 2,
            value: t('photo'), // Fotoğraf başlığı
        },
        {
            key: 3,
            value: t("Video") // Video başlığı
        }, {
            key: 4,
            value: t("document") // Dokuman başlığı
        }
    ]
    
    // Template türleri (şu anda kullanılmıyor gibi görünüyor)
    const templateTypeData = [
        {
            "key": 1,
            "value": "Metin"
        },
        {
            "key": 2,
            "value": "Fotoğraf"
        },
    ]
    // Ana form verilerini tutan state - template'in tüm bilgilerini içerir
    const [formData, setFormData] = useState({
        elementName: '', // Template adı
        languageCode: '', // Seçilen dil kodu
        category: '', // Template kategorisi
        templateType: 'TEXT', // Template türü (TEXT, IMAGE, VIDEO, DOCUMENT)
        templateFormat: '', // Template formatı
        vertical: 'TEXT', // Vertical tipi
        content: '', // Template içeriği (ana mesaj)
        header: t('none'), // Başlık tipi
        footer: '', // Alt bilgi
        buttons: '', // Butonlar JSON string olarak
        example: '', // Örnek mesaj (değişkenler doldurulmuş hali)
        enableSample: true, // Örnek mesajı aktif et
        allowTemplateCategoryChange: false, // Kategori değişikliğine izin ver
    });
    
    // Body değişken sayacı için ref
    const bodyCounterRef = useRef(0);
    // Textarea referansı - cursor pozisyonu için
    const textAreaRef = useRef(null);
    // Cursor pozisyonu state'i - değişken ekleme için
    const [cursorPos, setCursorPos] = useState(0);

    // Buton türleri için state'ler
    const [quickReplies, setQuickReplies] = useState([]); // Hızlı yanıt butonları
    const [phoneReplies, setPhoneReplies] = useState([]); // Telefon butonları
    const [urlReplies, setUrlReplies] = useState([]); // URL butonları
    const [inputErrors, setInputErrors] = useState({}); // Input hata durumları
    let navigate = useNavigate(); // Sayfa yönlendirme hook'u

    // UI state'leri
    const [headerType, setHeaderType] = useState(0); // Seçilen başlık türü (0=yok, 1=metin, 2=resim, 3=video, 4=dokuman)
    const [language, setLanguage] = useState(); // Seçilen dil
    const [inputs, setInputs] = useState(Array.from({ length: bodyCounterRef.current }, (_, index) => index)); // Dinamik değişken inputları
    const [selectedImage, setSelectedImage] = useState(); // Seçilen medya dosyası
    const [selectedHeaderText, setSelectedHeaderText] = useState(); // Başlık metni
    const [loadingPanel, setLoadingPanel] = useState(false) // Yükleme durumu
    const Icon = <LoadingOutlined style={{ fontSize: 35 }} spin /> // Yükleme ikonu

    /**
     * useEffect: Content değiştiğinde cursor pozisyonunu koruma
     * Template içeriği değiştiğinde textarea'da cursor pozisyonunu korur
     */
    useEffect(() => {
        const textarea = textAreaRef.current;
        if (textarea && cursorPos !== null) {
            textarea.focus();
            textarea.selectionStart = textarea.selectionEnd = cursorPos;
        }
    }, [formData.content])

    /**
     * Form input değişikliklerini yöneten ana fonksiyon
     * Template adı için özel validasyon kuralları uygular
     * @param {Event} e - Input change eventi
     */
    const handleChange = (e) => {
        const { name, value } = e.target;
        // Template adı için özel validasyon - sadece küçük harf, rakam ve alt çizgi
        if (name == "elementName" && value != '') {
            const regex = /^[a-z0-9_]+$/;
            if (!regex.test(value)) {
                message.error(t('templateNameInfo3'));
                return;
            }
        }
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };
    /**
     * Footer (alt bilgi) değişikliklerini yöneten fonksiyon
     * @param {Event} e - Input change eventi
     */
    const handleFooterChange = (e) => {
        const { value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            footer: value,
        }));
    };
    
    /**
     * Template değişkenlerini örnek metinle değiştiren fonksiyon
     * {{1}}, {{2}} gibi değişkenleri kullanıcının girdiği örnek değerlerle değiştirir
     * Sonucu example field'ına kaydeder
     */
    const GetTemplateVariablesDesc = () => {
        let updatedContent = formData.content;

        // inputs array'sindeki her değişken için işlem yapıyoruz
        inputs.map((item) => {
            // reg (örneğin: {{1}}) ile ilgili tüm eşleşmeleri value ile değiştiriyoruz
            updatedContent = updatedContent.replace(item.reg, item.value);
        });

        setFormData({ ...formData, example: updatedContent });
    }
    
    /**
     * Template değişkenlerini değiştiren yardımcı fonksiyon (verilen değer ile)
     * GetTemplateVariablesDesc'e benzer ama parametre olarak content alır
     * @param {string} value - İşlenecek template içeriği
     */
    const GetTemplateVariablesDesc2 = (value) => {
        let updatedContent = value;

        // inputs array'sindeki her değişken için işlem yapıyoruz
        inputs.map((item) => {
            // reg (örneğin: {{1}}) ile ilgili tüm eşleşmeleri value ile değiştiriyoruz
            updatedContent = updatedContent.replace(item.reg, item.value);
        });

        // formData.content'ı değiştirmiyoruz, sadece example'ı güncelliyoruz
        setFormData({ ...formData, example: updatedContent });
    }
    /**
     * Telefon numarasını WhatsApp formatına çeviren fonksiyon
     * Türkiye telefon numaralarını +90 formatına dönüştürür
     * @param {string} customerNumber - Ham telefon numarası
     * @returns {string} - Formatlanmış telefon numarası
     */
    function getCustomerNumber(customerNumber) {
        if (!customerNumber.startsWith("9")) {
            if (customerNumber.startsWith("0")) {
                // 0 ile başlayan numaralara 9 ekliyoruz (0532 -> 90532)
                customerNumber = "9" + customerNumber;
            } else if (customerNumber.startsWith("5")) {
                // 5 ile başlayan numaralara 90 ekliyoruz (532 -> 90532)
                customerNumber = "90" + customerNumber;
            }
        }
        return customerNumber;
    }
    /**
     * Form gönderimi ve template oluşturma işlemini yöneten ana fonksiyon
     * Tüm validasyonları yapar ve WhatsApp Business API'ye template gönderir
     * @param {Event} e - Form submit eventi
     */
    const handleSubmit = async (e) => {
        setLoadingPanel(true); // Yükleme panelini göster
        let hasError = false; // Hata durumu kontrolü

        // Hızlı yanıt butonları validasyonu
        const updatedReply = quickReplies.map((item) => {
            if (item.value == null || item.value == undefined || item.value.trim() === '') {
                hasError = true;
                return { ...item, hasError: true };
            }
            return { ...item, hasError: false };
        });

        setQuickReplies(updatedReply);

        // Hızlı yanıt butonlarında boş değer kontrolü
        quickReplies.map((item) => {
            if (item.value == null || item.value == undefined || item.value.trim() === '') {
                message.error("Buton Mesajları Boş Olamaz")
                return;
            }
        });

        // Template değişkenleri validasyonu
        const updatedInputs = inputs.map((item) => {
            if (item.value == null || item.value == undefined || item.value.trim() === '') {
                hasError = true;
                return { ...item, hasError: true };
            }
            return { ...item, hasError: false };
        });

        setInputs(updatedInputs);

        // Değişkenlerde boş değer kontrolü
        inputs.map((item) => {
            if (item.value == null || item.value == undefined || item.value.trim() === '') {
                message.error("Değişkenler Boş Olamaz")
                return;
            }
        });

        // Eğer herhangi bir hata varsa işlemi durdur
        if (hasError) {
            setLoadingPanel(false);
            return; 
        }

        // Ana form alanları için validasyon hataları
        const errors = {}

        // Template adı zorunlu alan kontrolü
        if (!formData.elementName) {
            message.error(t('templateNameRequired'));
            errors.elementName = true;
        }

        // Dil seçimi zorunlu alan kontrolü
        if (!formData.languageCode) {
            message.error(t('languageSelectionRequired'));
            errors.languageCode = true;
        }

        // Template içeriği zorunlu alan kontrolü
        if (!formData.content) {
            message.error(t('templateContentRequired'));
            errors.content = true;
        }

        // Eğer zorunlu alanlar boşsa işlemi durdur
        if (Object.keys(errors).length > 0) {
            setInputErrors(errors); // Input'lara error status vermek için
            setLoadingPanel(false);
            return;
        }

        // Butonları WhatsApp API formatına dönüştürme
        const keyValueList = [];
        
        // Hızlı yanıt butonlarını ekle
        quickReplies.map((quick) => {
            const model = {
                type: "QUICK_REPLY",
                text: quick.value
            }
            keyValueList.push(model)
        })
        
        // URL butonlarını ekle
        urlReplies.map((quick) => {
            const model = {
                type: "URL",
                text: quick.value,
                url: quick.url
            }
            keyValueList.push(model)
        })
        
        // Telefon butonlarını ekle
        phoneReplies.map((quick) => {
            const model = {
                type: "PHONE_NUMBER",
                text: quick.header,
                phone_number: getCustomerNumber(quick.value)
            }
            keyValueList.push(model)
        })
        // WhatsApp API'ye gönderilecek parametreleri hazırla
        var params = {
            elementName: formData.elementName, // Template adı
            languageCode: formData.languageCode, // Seçilen dil
            category: "MARKETING", // Template kategorisi (sabit: MARKETING)
            // Header tipine göre template türünü belirle
            templateType: headerType == 1 ? "TEXT" : headerType == 2 ? "IMAGE" : headerType == 3 ? "VIDEO" : headerType == 4 ? "DOCUMENT" : "TEXT",
            vertical: "Marketing Message for Customers", // Template açıklaması
            content: formData.content || "", // Ana mesaj içeriği
            header: selectedHeaderText || "", // Başlık metni
            footer: t("stopTemplateMessage"), // Alt bilgi (sabit: durdurmak için mesaj)
            example: formData.example || "", // Örnek mesaj
            enableSample: formData.enableSample || false, // Örnek mesajı etkinleştir
            allowTemplateCategoryChange: formData.allowTemplateCategoryChange || false, // Kategori değişikliğine izin ver
            buttons: JSON.stringify(keyValueList), // Butonları JSON string olarak
            image: selectedImage || null // Seçilen medya dosyası
        };
        
        // API çağrısı yap
        var result = await network.postFormData("/TemplateMessage/CreateTemplateMessage", params);
        const { data } = result;
        setLoadingPanel(false); // Yükleme panelini kapat
        
        // Sonuç kontrolü ve kullanıcı bilgilendirme
        if (result.isSuccess && data.isSuccess) {
            message.success(t('templateCreatedSuccessfully'));
            // 1 saniye sonra template listesine yönlendir
            setTimeout(() => {
                navigate(`/templates`)
            }, 1000);
        } else {
            message.error(data.message);
        }
    };
    /**
     * Hızlı yanıt butonlarının değerini güncelleyen fonksiyon
     * @param {number} index - Güncellenecek butonun indeksi
     * @param {string} value - Yeni buton metni
     */
    const handleInputChange = (index, value) => {
        const newQuickReplies = [...quickReplies];
        newQuickReplies[index].value = value;
        setQuickReplies(newQuickReplies);
    };
    
    /**
     * URL butonlarının metin değerini güncelleyen fonksiyon
     * @param {number} index - Güncellenecek butonun indeksi
     * @param {string} value - Yeni buton metni
     */
    const handleUrlChange = (index, value) => {
        const newQuickReplies = [...urlReplies];
        newQuickReplies[index].value = value;
        setUrlReplies(newQuickReplies);
    };
    
    /**
     * URL butonlarının URL değerini güncelleyen fonksiyon
     * @param {number} index - Güncellenecek butonun indeksi
     * @param {string} value - Yeni URL adresi
     */
    const handleUrl2Change = (index, value) => {
        const newQuickReplies = [...urlReplies];
        newQuickReplies[index].url = value;
        setUrlReplies(newQuickReplies);
    };
    
    /**
     * Telefon butonlarının telefon numarası değerini güncelleyen fonksiyon
     * @param {number} index - Güncellenecek butonun indeksi
     * @param {string} value - Yeni telefon numarası
     */
    const handlePhoneChange = (index, value) => {
        const newQuickReplies = [...phoneReplies];
        newQuickReplies[index].value = value;
        setPhoneReplies(newQuickReplies);
    };
    
    /**
     * Telefon butonlarının başlık metni değerini güncelleyen fonksiyon
     * @param {number} index - Güncellenecek butonun indeksi
     * @param {string} value - Yeni başlık metni
     */
    const handlePhoneHeaderChange = (index, value) => {
        const newQuickReplies = [...phoneReplies];
        newQuickReplies[index].header = value;
        setPhoneReplies(newQuickReplies);
    };

    /**
     * Hızlı yanıt butonunu listeden kaldıran fonksiyon
     * @param {number} index - Kaldırılacak butonun indeksi
     */
    const clearInput = (index) => {
        const newQuickReplies = quickReplies.filter((reply, idx) => idx !== index);
        setQuickReplies(newQuickReplies); // Yeni array'i state'e set ediyoruz
    };
    
    /**
     * Telefon butonunu listeden kaldıran fonksiyon
     * @param {number} index - Kaldırılacak butonun indeksi
     */
    const clearPhoneInput = (index) => {
        const newQuickReplies = phoneReplies.filter((reply, idx) => idx !== index);
        setPhoneReplies(newQuickReplies); // Yeni array'i state'e set ediyoruz
    };
    
    /**
     * URL butonunu listeden kaldıran fonksiyon
     * @param {number} index - Kaldırılacak butonun indeksi
     */
    const clearUrlInput = (index) => {
        const newQuickReplies = urlReplies.filter((reply, idx) => idx !== index);
        setUrlReplies(newQuickReplies); // Yeni array'i state'e set ediyoruz
    };


    /**
     * Yeni telefon butonu ekleyen fonksiyon
     * Telefon numarası ile arama yapılabilecek buton oluşturur
     */
    const phoneOnClick = () => {
        const newReplyObject = {
            id: phoneReplies.length + 1, // ID'yi dinamik olarak oluşturuyoruz
            value: '', // Telefon numarası
            header: '' // Buton başlık metni
        };
        setPhoneReplies((prevReplies) => [...prevReplies, newReplyObject]);
    }
    
    /**
     * Yeni URL butonu ekleyen fonksiyon
     * Web sitesine yönlendirme yapılabilecek buton oluşturur
     */
    const urlOnClick = () => {
        const newReplyObject = {
            id: urlReplies.length + 1, // ID'yi dinamik olarak oluşturuyoruz
            value: '', // Buton metni
            url: '' // Yönlendirilecek URL
        };
        setUrlReplies((prevReplies) => [...prevReplies, newReplyObject]);
    }
    
    /**
     * Yeni hızlı yanıt butonu ekleyen fonksiyon
     * Kullanıcının tek tıkla yanıt verebileceği buton oluşturur
     */
    const addQuickReply = () => {
        const newReplyObject = {
            id: quickReplies.length + 1, // ID'yi dinamik olarak oluşturuyoruz
            value: '', // Buton metni
            hasError: false // Hata durumu
        };
        setQuickReplies((prevReplies) => [...prevReplies, newReplyObject]);
    };

    /**
     * Hızlı yanıt butonlarının UI'ını render eden fonksiyon
     * Her buton için input alanı ve silme butonu içerir
     * @returns {JSX.Element} Hızlı yanıt butonları UI'ı
     */
    const GetQuickReply = () => {
        return (
            <>
                {quickReplies.map((reply, index) => (
                    <div
                        key={reply.id}
                        className="row"
                        style={{ display: 'flex', alignItems: 'center' }}
                    >
                        <Input
                            name={`quiclyButton${reply.id}`}
                            placeholder={t('quickReplyPlaceholder')}  // Placeholder için çeviri
                            value={reply.value}
                            onChange={(e) => { handleInputChange(index, e.target.value) }}
                            style={{ marginBottom: '8px', marginTop: '12px', flexGrow: 1 }}
                            maxLength={20}
                            showCount
                            status={reply.hasError ? 'error' : ''}
                        />
                        <CloseCircleOutlined
                            onClick={() => clearInput(index)} // Çarpıya tıklandığında ilgili input'u temizle
                            style={{
                                fontSize: '20px',
                                color: '#1890ff',
                                cursor: 'pointer',
                                marginLeft: '8px',
                            }}
                        />
                    </div>
                ))}
            </>
        );
    }
    /**
     * Telefon butonlarının UI'ını render eden fonksiyon
     * Her buton için başlık ve telefon numarası input alanları içerir
     * @returns {JSX.Element} Telefon butonları UI'ı
     */
    const GetPhoneCta = () => {
        return (
            <>
                {phoneReplies.map((reply, index) => (
                    <div
                        key={reply.id}
                        className="row"
                        style={{ display: 'flex', alignItems: 'center' }}
                    >
                        <Input
                            name={`phone${reply.id}`}
                            placeholder={t('phoneButtonTitle')}  // Placeholder için çeviri
                            value={reply.header}
                            onChange={(e) => handlePhoneHeaderChange(index, e.target.value)}
                            style={{ marginBottom: '8px', marginTop: '12px', flexGrow: 1, marginRight: "10px" }}
                            maxLength={20}
                            showCount
                        />
                        <Input
                            name={`phone2${reply.id}`}
                            placeholder={t('phoneButtonValue')}  // Placeholder için çeviri
                            value={reply.value}
                            onChange={(e) => handlePhoneChange(index, e.target.value)}
                            style={{ marginBottom: '8px', marginTop: '4px', flexGrow: 1 }}
                        />
                        <CloseCircleOutlined
                            onClick={() => clearPhoneInput(index)} // Çarpıya tıklandığında ilgili input'u temizle
                            style={{
                                fontSize: '20px',
                                color: '#1890ff',
                                cursor: 'pointer',
                                marginLeft: '8px',
                            }}
                        />
                    </div>
                ))}
            </>
        );
    }
    /**
     * URL butonlarının UI'ını render eden fonksiyon
     * Her buton için metin ve URL input alanları içerir
     * @returns {JSX.Element} URL butonları UI'ı
     */
    const GetUrlCta = () => {
        return (
            <>
                {urlReplies.map((reply, index) => (
                    <div
                        key={reply.id}
                        className="row"
                        style={{ display: 'flex', alignItems: 'center' }}
                    >
                        <Input
                            name={`cta${reply.id}`}
                            placeholder={t('urlButtonTitle')}  // Placeholder için çeviri
                            value={reply.value}
                            onChange={(e) => handleUrlChange(index, e.target.value)}
                            style={{ marginBottom: '8px', marginTop: '4px', flexGrow: 1, marginRight: "10px" }}
                            maxLength={20}
                            showCount
                        />
                        <Input
                            name={`cta2${reply.id}`}
                            placeholder={t('urlButtonValue')}  // Placeholder için çeviri
                            value={reply.url}
                            onChange={(e) => handleUrl2Change(index, e.target.value)}
                            style={{ marginBottom: '8px', marginTop: '12px', flexGrow: 1 }}
                        />
                        <CloseCircleOutlined
                            onClick={() => clearUrlInput(index)} // Çarpıya tıklandığında ilgili input'u temizle
                            style={{
                                fontSize: '20px',
                                color: '#1890ff',
                                cursor: 'pointer',
                                marginLeft: '8px',
                            }}
                        />
                    </div>
                ))}
            </>
        );
    }
    /**
     * Dil seçimi değişikliklerini yöneten fonksiyon
     * @param {string} value - Seçilen dilin görünen adı
     * @param {Object} key - Seçilen dil objesi (key ve value içerir)
     */
    const handleLanguageChange = (value, key) => {
        setLanguage(key.value);
        setFormData({
            ...formData,
            languageCode: key.key
        })
    }
    
    /**
     * Başlık türü değişikliklerini yöneten fonksiyon
     * @param {string} value - Seçilen başlık türünün adı
     * @param {Object} key - Seçilen başlık türü objesi
     */
    const handleHeaderChange = (value, key) => {
        setHeaderType(key.key);
        setFormData({
            ...formData,
            header: key.value
        })
    }
    /**
     * Dosya yükleme öncesi validasyon fonksiyonu
     * Dosya türü, boyutu ve adını kontrol eder
     * @param {File} file - Yüklenecek dosya objesi
     * @returns {boolean|Upload.LIST_IGNORE} Dosya geçerliyse true, değilse Upload.LIST_IGNORE
     */
    const beforeFileUpload = (file) => {
        // Desteklenen dosya türlerini kontrol et
        const isImage = file.type === 'image/jpeg' || file.type === 'image/png';
        const isVideo = file.type === 'video/mp4';
        const isDocument = file.type === 'application/pdf';

        // Dosya adı validasyonu - sadece harf, rakam, nokta, alt çizgi ve tire
        const isValidFileName = /^[a-zA-Z0-9._-]+$/.test(file.name);

        // Dosya boyutu kontrolleri
        const isValidImageSize = file.size / 1024 / 1024 < 5; // 5MB limit
        const isValidVideoSize = file.size / 1024 / 1024 < 16; // 16MB limit
        const isValidDocumentSize = file.size / 1024 / 1024 < 100; // 100MB limit

        // Dosya adı geçerli değilse hata ver
        if (!isValidFileName) {
            message.error(t('invalidFileName'));
            return Upload.LIST_IGNORE;
        }
        
        // Resim boyutu kontrolü
        if (isImage && !isValidImageSize) {
            message.error(t('imageSizeError'));
            return Upload.LIST_IGNORE;
        }
        
        // Video boyutu kontrolü
        if (isVideo && !isValidVideoSize) {
            message.error(t('videoSizeError'));
            return Upload.LIST_IGNORE;
        }
        
        // Dokuman boyutu kontrolü
        if (isDocument && !isValidDocumentSize) {
            message.error(t('documentSizeError'));
            return Upload.LIST_IGNORE;
        }

        // Desteklenmeyen dosya türü kontrolü
        if (!isImage && !isVideo && !isDocument) {
            message.error(t('invalidFileFormat'));
            return Upload.LIST_IGNORE;
        }

        return true; // Dosya geçerli, yükleme işlemine devam edebilir
    }
    /**
     * Template içerik değişikliklerini yöneten fonksiyon
     * İçerik değiştiğinde değişkenleri günceller ve örnek mesajı yeniler
     * @param {Event} e - Textarea change eventi
     */
    const handleContentChange = (e) => {
        // İçerik boşsa değişken sayacını sıfırla
        if (e.target.value.length == 0) {
            bodyCounterRef.current = 0;
        }
        // Değişkenleri güncelle ve örnek mesajı oluştur
        GetTemplateVariablesDesc2(e.target.value);
        setFormData({
            ...formData,
            content: e.target.value
        });
    }
    
    /**
     * Medya (başlık) değişikliklerini yöneten fonksiyon
     * Başlık türüne göre metin veya dosya işlemlerini yapar
     * @param {Event} e - Input/Upload change eventi
     */
    const handleMediaChange = (e) => {
        if (headerType == 1) {
            // Metin başlığı için
            setSelectedHeaderText(e.target.value)
        }
        else if (headerType == 2 || headerType == 3 || headerType == 4) {
            // Medya dosyası için (resim, video, dokuman)
            setSelectedImage(e.file.originFileObj);
        }
    }

    /**
     * Seçili metni kalın yapmak için * karakterleri ekleyen fonksiyon
     * WhatsApp'ta *metin* formatında kalın yazı oluşturur
     */
    const boldText = () => {
        const textarea = textAreaRef.current.resizableTextArea.textArea;
        const start = textarea.selectionStart; // Seçimin başlangıç pozisyonu
        const end = textarea.selectionEnd; // Seçimin bitiş pozisyonu

        // Metni üç parçaya böl: öncesi, seçili kısım, sonrası
        const before = formData.content.substring(0, start);
        const selected = formData.content.substring(start, end);
        const after = formData.content.substring(end);

        // Seçili metni * karakterleri arasına al
        const newValue = `${before}*${selected}*${after}`;
        setFormData({
            ...formData,
            content: newValue,
        });
    };

    /**
     * Seçili metni italik yapmak için _ karakterleri ekleyen fonksiyon
     * WhatsApp'ta _metin_ formatında italik yazı oluşturur
     */
    const italicText = () => {
        const textarea = textAreaRef.current.resizableTextArea.textArea;
        const start = textarea.selectionStart; // Seçimin başlangıç pozisyonu
        const end = textarea.selectionEnd; // Seçimin bitiş pozisyonu

        // Metni üç parçaya böl: öncesi, seçili kısım, sonrası
        const before = formData.content.substring(0, start);
        const selected = formData.content.substring(start, end);
        const after = formData.content.substring(end);

        // Seçili metni _ karakterleri arasına al
        const newValue = `${before}_${selected}_${after}`;
        setFormData({
            ...formData,
            content: newValue,
        });
    };


    /**
     * Template'e yeni değişken ekleyen fonksiyon
     * {{1}}, {{2}} formatında değişkenler oluşturur ve cursor pozisyonuna ekler
     */
    const addBodyVariable = () => {
        const length = inputs.length + 1; // Yeni değişken numarası
        const variableText = `{{${length}}}`; // Değişken formatı

        const textarea = textAreaRef.current;
        const currentPos = cursorPos; // Mevcut cursor pozisyonu

        // Cursor pozisyonuna değişkeni ekle
        const newContent =
            formData.content.slice(0, currentPos) +
            variableText +
            formData.content.slice(currentPos);

        // Form içeriğini güncelle
        setFormData({
            ...formData,
            content: newContent,
        });

        // Yeni input alanı oluştur
        setInputs((prevInputs) => [
            ...prevInputs,
            {
                id: uuidv4(), // Benzersiz ID
                reg: variableText, // Değişken regex pattern'i
                var: t('variable', { count: prevInputs.length + 1 }), // Değişken etiketi
                value: '', // Değişken değeri (boş başlar)
            },
        ]);

        // Cursor pozisyonunu değişken sonrasına taşı
        setCursorPos(currentPos + variableText.length);
    };
    /**
     * Değişkeni template'den ve input listesinden kaldıran fonksiyon
     * Hem template içeriğinden değişkeni siler hem de input alanını kaldırır
     * @param {string} id - Kaldırılacak değişkenin benzersiz ID'si
     */
    const handleRemove = (id) => {
        // Kaldırılacak değişkeni bul
        const inputToRemove = inputs.find((input) => input.id === id);
        if (!inputToRemove) return;

        // Template içeriğinden değişkeni kaldır
        const updatedContent = formData.content.replace(inputToRemove.reg, '');

        // Input listesinden değişkeni kaldır
        const updatedInputs = inputs.filter((input) => input.id !== id);

        // State'leri güncelle
        setInputs(updatedInputs);
        setFormData({
            ...formData,
            content: updatedContent,
        });
    };
    /**
     * Dinamik değişken input'larının UI'ını render eden fonksiyon
     * Her değişken için label, input ve silme butonu içerir
     * @param {Object} input - Değişken objesi (id, var, value, reg içerir)
     * @returns {JSX.Element} Değişken input UI'ı
     */
    const GetDinamicInputs = (input) => {
        return (
            <Row gutter={16} key={input.id}>
                <Col span={6} style={{ display: 'flex', alignItems: 'center', marginTop: 10, marginBottom: 5 }}>
                    <strong>{input.var} :</strong>
                </Col>
                <Col span={16}>
                    <Input
                        key={`input-${input.id}`}
                        placeholder={t('inputPlaceholder')}
                        style={{ marginTop: 10, marginBottom: 5 }}
                        value={input.value}
                        onChange={(e) => {
                            const updatedInputs = inputs.map((item) =>
                                item.id === input.id ? { ...item, value: e.target.value } : item
                            );
                            setInputs(updatedInputs);
                            GetTemplateVariablesDesc();
                        }}
                        status={input.hasError ? 'error' : ''}
                    />
                </Col>
                <Col span={2} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <CloseOutlined
                        onClick={() => handleRemove(input.id)}
                        style={{ fontSize: '18px', color: '#1890ff', cursor: 'pointer' }}
                    />
                </Col>
            </Row>
        );
    };

    /**
     * Tüm değişken input'larını ve uyarı mesajını render eden fonksiyon
     * Değişkenler varsa uyarı mesajı ve input'ları gösterir
     * @returns {JSX.Element} Değişkenler bölümü UI'ı
     */
    const GetVariables = () => {
        return (
            <>
                {inputs.length > 0 ? (
                    <div>
                        {/* Değişkenler hakkında bilgilendirici uyarı mesajı */}
                        <div className="warning-message" style={{
                            backgroundColor: '#fffbe6',
                            border: '1px solid #ffe58f',
                            padding: '8px 15px',
                            borderRadius: '8px',
                            marginBottom: '16px',
                            color: '#ad6800',
                            marginTop: "10px"
                        }}>
                            <span style={{ marginRight: '8px' }}>⚠️</span>
                            {t("variableInfo")}
                        </div>
                        {/* Tüm değişken input'larını render et */}
                        {inputs.map((index) => GetDinamicInputs(index))}
                    </div>
                ) : (<></>)}
            </>
        );
    }

    // Toplam buton sayısını hesapla (WhatsApp maksimum 10 buton sınırı için)
    const totalReplyCount = quickReplies.length + urlReplies.length + phoneReplies.length;

    /**
     * Ana component render'ı
     * Template oluşturma formunu ve tüm UI bileşenlerini içerir
     */
    return (
        // Yükleme durumunda spinner göster
        <Spin spinning={loadingPanel} indicator={Icon} >
            {/* Ana container */}
            <div style={{
                maxWidth: '98%',
                margin: '0 auto',
                padding: '30px',
                backgroundColor: '#fff',
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                border: '1px solid #d9d9d9'
            }}>
                {/* Başlık ve geri dönüş butonu satırı */}
                <div className='row-justify-between'>
                    <h2 style={{ marginBottom: '20px', fontFamily: 'Arial, sans-serif' }}>{t('createTemplate')}</h2>
                    <Flex className="mb-1" alignItems="center" justify='flex-end' mobileFlex={false}>
                        <div className="mb-3">
                            {/* <Button href={"templates"} type="primary" block>{t('backToTemplate')}</Button> */}
                            <ReusableButton
                                variant="campaign"
                                text={t('backToTemplate')}
                                // onClick={sendTestTemplateMessage}
                                href={"templates"}
                                icon={<UnorderedListOutlined />}
                            />
                        </div>
                    </Flex>
                </div>

                {/* Template Name and Language - İki bileşen yan yana */}
                <Row gutter={16}>
                    {/* Template adı input alanı */}
                    <Col span={12}>
                        <TemplateInput
                            title={t('templateName')}
                            description={t('templateNameInfo1')}
                            value={formData.elementName}
                            onChange={handleChange}
                            infoMessage={t('templateNameInfo2')}
                            subDesc={t('templateNameInfo3')}
                            isRequired={true}
                            status={inputErrors.elementName ? "error" : ""}
                        />
                    </Col>
                    {/* Dil seçimi dropdown'ı */}
                    <Col span={12}>
                        <TemplateSelectBox
                            title={t('language')}
                            description={t('languageDescription')}
                            value={language}
                            onChange={handleLanguageChange}
                            languageData={languageData}
                            infoMessage={t('languageInfo')}
                            isRequired={true}
                            status={inputErrors.languageCode ? "error" : ""}
                        />
                    </Col>
                    {/* <Col span={6}>
                    <TemplateSelectBox
                        title="Şablon Tipi"
                        description="Lütfen şablon tipini seçin."
                        // value={formData.templateType}
                        onChange={handleTemplateTypeChange}
                        languageData={templateTypeData}
                        infoMessage="Şablonunuzu göndereceğiniz tipi seçebilirsiniz."
                        isRequired={true}
                    />
                </Col> */}
                </Row>

                {/* Medya seçimi ve içerik alanı */}
                <Row gutter={16} style={{ marginTop: '20px', display: 'flex', alignItems: 'stretch' }}>
                    {/* Başlık (Header) medya seçimi */}
                    <Col
                        span={12}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            minHeight: '100%', // Kolonların yüksekliklerinin eşit olmasını sağlar
                        }}
                    >
                        <TemplateMediaSelectBox
                            title={t('headerTitle')}
                            description={t('headerDescription')}
                            value={formData.header}
                            onChange={handleHeaderChange}
                            languageData={headerData}
                            infoMessage={t('headerInfoMessage')}
                            isRequired={false}
                            beforeFileUpload={beforeFileUpload}
                            mediaType={headerType}
                            handleMediaChange={handleMediaChange}
                        />
                    </Col>

                    {/* Template içerik alanı */}
                    <Col
                        span={12}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            minHeight: '100%', // Kolonların yüksekliklerinin eşit olmasını sağlar
                        }}
                    >

                        {/* Template içerik editörü container'ı */}
                        <div style={{
                            marginBottom: '20px',
                            fontFamily: 'Arial, sans-serif',
                            padding: '20px',
                            border: '1px solid #d9d9d9',
                            borderRadius: '8px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                            backgroundColor: '#fff',
                            height: '100%',
                            minHeight: "420px"
                        }}>
                            {/* Ana template içerik textarea'sı */}
                            <TemplateTextArea
                                title={t('templateContentTitle')}
                                description={t('templateContentDescription')}
                                value={formData.content}
                                onChange={handleContentChange}
                                isRequired={true}
                                isVariables={true}
                                bodyCounterRef={bodyCounterRef}
                                addBodyVariable={addBodyVariable}
                                textAreaRef={textAreaRef}
                                setCursorPos={setCursorPos}
                                minHeight={420}
                                status={inputErrors.content ? "error" : ""}
                                addBold={boldText}
                                addItalic={italicText}
                            />
                            {/* Dinamik değişken input'ları */}
                            {GetVariables()}
                        </div>

                    </Col>
                </Row>


                {/* Butonlar bölümü */}
                <Row gutter={16} style={{ marginTop: '20px' }}>
                    <Col span={12}>
                        <div style={{
                            backgroundColor: '#fff',
                            padding: '20px',
                            borderRadius: '8px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                            minHeight: 207
                        }}>
                            {/* Butonlar başlık satırı */}
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '8px',
                            }}>
                                <div style={{
                                    display: 'flex',
                                }}>
                                    <h3 style={{
                                        fontSize: '18px',
                                        fontWeight: '600',
                                        color: '#333',
                                        fontFamily: 'Helvetica, sans-serif',
                                        marginRight: '10px',
                                    }}>
                                        {t('buttonsTitle')}
                                    </h3>
                                    {/* Opsiyonel badge'i */}
                                    <div style={{
                                        padding: '2px 6px',
                                        backgroundColor: '#FFF6E6',
                                        borderRadius: '6px',
                                        fontSize: '14px',
                                        color: '#000010',
                                        fontWeight: '500',
                                        marginRight: '10px',
                                        height: '25px',
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                        {t('optional')}
                                    </div>
                                </div>
                                {/* Bilgi tooltip'i */}
                                <Tooltip title={t('tooltipInfo')}>
                                    <InfoCircleOutlined style={{ color: '#1890ff', fontSize: '18px' }} />
                                </Tooltip>
                            </div>

                            {/* Buton açıklama metni */}
                            <p style={{
                                fontSize: '14px',
                                color: '#595959',
                                marginBottom: '16px',
                                fontFamily: 'Verdana, sans-serif'
                            }}>
                                {t('buttonSelectionInfo')}
                            </p>

                            {/* Buton ekleme butonları */}
                            <div style={{ marginBottom: '12px', gap: "10px" }}>
                                {/* Hızlı yanıt butonu ekleme */}
                                <Button
                                    type="button"
                                    disabled={totalReplyCount > 9}
                                    onClick={addQuickReply}
                                    icon={<PlusOutlined />}
                                    style={{ marginRight: 10 }}
                                >
                                    {t('quickReplyButton')}
                                </Button>

                                {/* URL butonu ekleme */}
                                <Button
                                    type="button"
                                    disabled={urlReplies.length > 1 || totalReplyCount > 9}
                                    onClick={urlOnClick}
                                    style={{ marginRight: 10 }}
                                    icon={<LinkOutlined />}
                                >
                                    {t('urlButton')}
                                </Button>

                                {/* Telefon butonu ekleme */}
                                <Button
                                    type="button"
                                    disabled={phoneReplies.length > 0 || totalReplyCount > 9}
                                    onClick={phoneOnClick}
                                    icon={<PhoneOutlined />}
                                    style={{ marginTop: "10px" }}
                                >
                                    {t('phoneButton')}
                                </Button>
                                
                                {/* Eklenen butonların render'ı */}
                                {GetQuickReply()}
                                {GetPhoneCta()}
                                {GetUrlCta()}
                            </div>
                        </div>
                    </Col>
                </Row>

                {/* Template oluşturma butonu */}
                <div className='mt-3 d-flex justify-content-end' style={{ width: "%100" }}>
                    <div>
                        <ReusableButton
                            variant="campaign"
                            text={t('createTemplateText')}
                            onClick={handleSubmit}
                            icon={<PlusCircleOutlined />}
                        />
                    </div>
                </div>

            </div>
        </Spin>
    );
}


export default CreateTemplate